import { DialogOptions } from '../../../models/modal.model'
import {
  GenericNotificationCode,
  NotificationOptions,
  parseGenericNotification,
} from '../../../models/notification.model'
import { SupplierOrder } from '../models/supplier-order.entity'

export type SupplierOrderNotificationCode =
  | GenericNotificationCode
  | 'ATTACHMENTS_FOUND'
  | 'NO_PROVISIONING_PRODUCTS'
  | 'SUPPLIER_ORDER_CANCELED'
  | 'SUPPLIER_ORDER_CLOSED'
  | 'SUPPLIER_ORDER_DELETED'
  | 'SUPPLIER_ORDER_NOT_FOUND'
  | 'SUPPLIER_ORDER_PRINTED'
  | 'SUPPLIER_ORDER_PROCESSED'
  | 'SUPPLIER_ORDER_SAVED'

export type SupplierOrderModalCode =
  | 'SUPPLIER_ORDER_CANCEL'
  | 'SUPPLIER_ORDER_DELETION'

/**
 * Parse supplier order code to a notification
 * @param code - the supplier order notification code
 * @returns the notification options
 */
export function parseSupplierOrderNotification(
  code?: SupplierOrderNotificationCode,
): NotificationOptions {
  switch (code) {
    case 'ATTACHMENTS_FOUND':
      return {
        message: 'Supplier orders with attachments cannot be deleted',
        color: 'error',
      }
    case 'NO_PROVISIONING_PRODUCTS':
      return {
        message: 'No product to be ordered',
        color: 'info',
      }
    case 'SUPPLIER_ORDER_CANCELED':
      return {
        message: 'Supplier order canceled successfully',
        color: 'success',
      }
    case 'SUPPLIER_ORDER_CLOSED':
      return {
        message: 'Supplier order closed successfully',
        color: 'success',
      }
    case 'SUPPLIER_ORDER_DELETED':
      return {
        message: 'Supplier order deleted successfully',
        color: 'success',
      }
    case 'SUPPLIER_ORDER_NOT_FOUND':
      return {
        message: 'Supplier order not found',
        color: 'error',
      }
    case 'SUPPLIER_ORDER_PRINTED':
      return {
        message: 'Supplier order printed',
        color: 'success',
      }
    case 'SUPPLIER_ORDER_PROCESSED':
      return {
        message: 'Supplier order updated successfully',
        color: 'success',
      }
    case 'SUPPLIER_ORDER_SAVED':
      return {
        message: 'Supplier order saved successfully',
        color: 'success',
      }
    default:
      return parseGenericNotification(code)
  }
}

/**
 * Parse supplier order code to an modal
 * @param code - the supplier order modal code
 * @param supplierOrder - the supplier order object
 * @returns the modal settings
 */
export function parseSupplierOrderModal(
  code: SupplierOrderModalCode,
  supplierOrder?: SupplierOrder,
): DialogOptions {
  switch (code) {
    case 'SUPPLIER_ORDER_CANCEL': {
      return {
        title: 'Cancel supplier order',
        message:
          'The supplier order will be permanently cancelled and it will no longer be possible to process it or make any type of modification',
        buttons: ['Cancel', 'Confirm'],
      }
    }
    case 'SUPPLIER_ORDER_DELETION': {
      const grName = supplierOrder?.header.orderNumber
      return {
        title: 'Delete supplier order',
        message:
          'You are about to delete the supplier order <strong>%s</strong>. Proceed with deletion?',
        messageParams: grName ? [grName] : undefined,
        buttons: ['Cancel', 'Confirm'],
      }
    }
    default:
      return {}
  }
}
